import VPageCardTicketAddRecord from './index.vue';

export default {
  install: (Vue) => Vue.component('VPageCardTicketAddRecord', VPageCardTicketAddRecord),
};
